// Las teclas que mueven el cursor del Estudio de Video —
// ADR-2026-11-02-la-timeline-sigue-al-cursor.
//
// Antes no había ninguna: para volver atrás había que ir a la regla de arriba (Nacho,
// 2/11: "no se puede retroceder en el timeline"). Son las de cualquier editor:
// ← / → un cuadro, con Shift un segundo, Inicio y Fin a las puntas.

/** Un cuadro del preview: el Estudio trabaja a 30 fps. */
export const CUADRO_S = 1 / 30;

/**
 * Adónde va el cursor con esta tecla, o null si la tecla no es de la timeline.
 * El resultado ya viene recortado a [0, fin] (con `fin` 0 = timeline vacía, sin tope).
 */
export function tiempoConLaTecla(
  tecla: string,
  conShift: boolean,
  ahora: number,
  fin: number,
): number | null {
  let t: number;
  if (tecla === 'Home') t = 0;
  else if (tecla === 'End') t = fin;
  else if (tecla === 'ArrowLeft' || tecla === 'ArrowRight') {
    const paso = conShift ? 1 : CUADRO_S;
    t = ahora + (tecla === 'ArrowLeft' ? -paso : paso);
  } else return null;
  if (!Number.isFinite(t)) return null;
  return Math.max(0, fin > 0 ? Math.min(fin, t) : t);
}
